class InternalError extends Error {
  /**
   *
   * @param {Error} error
   */
  constructor(error) {
    super(error)

    this.error = error
  }

  /**
   *
   * @return {Error}
   */
  getError() {
    return this.error
  }
}

export default InternalError
